import { CreateGameRoomOptions } from "@presidents/game-engine/src/game-room";

export type FetchCreateRoomOptions = Pick<
  CreateGameRoomOptions,
  "rules" | "quick" | "gameLimit"
>;

export default async function fetchCreateRoom(
  token: string,
  options: FetchCreateRoomOptions
) {
  try {
    const res = await fetch("/api/create-room", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(options)
    });
    const data = (await res.json()) as { roomId: string; created: number };
    return {
      data,
      error: null
    };
  } catch (err) {
    console.error(err);
    return { data: null, error: err };
  }
}
